import { Companion_getInstance2oum3kfs9lqez as Companion_getInstance } from '../type/SecretId.mjs';
import {
  notNull3hndh47e9bowl as notNull,
  Builder320ghmibyd2no as Builder,
  Builder3t31vflw4km89 as Builder_0,
  CompiledVariablecaz6ndkw7us2 as CompiledVariable,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { Companion_getInstance3g9vumyncsnd3 as Companion_getInstance_0 } from '../type/GraphQLString.mjs';
import { Companion_getInstance1rfg16jb4mnme as Companion_getInstance_1 } from '../type/DateTimeISO.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Companion_getInstancelxiiovscp80h as Companion_getInstance_2 } from '../type/SecretToken.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance_3 } from '../type/Mutation.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CreateSecretMutationSelectionsClass;
function CreateSecretMutationSelections() {
  if (CreateSecretMutationSelectionsClass === VOID) {
    class $ {
      constructor() {
        CreateSecretMutationSelections_instance = this;
        this.__createSecret_1 = listOf([(new (Builder())('secretId', notNull(Companion_getInstance().type_1))).build_1k0s4u_k$(), (new (Builder())('description', notNull(Companion_getInstance_0().type_1))).build_1k0s4u_k$(), (new (Builder())('createdTimestamp', notNull(Companion_getInstance_1().type_1))).build_1k0s4u_k$(), (new (Builder())('lastUsedTimestamp', Companion_getInstance_1().type_1)).build_1k0s4u_k$(), (new (Builder())('secretToken', notNull(Companion_getInstance_0().type_1))).build_1k0s4u_k$()]);
        this.__root_1 = listOf_0((new (Builder())('createSecret', Companion_getInstance_2().type_1)).arguments_2si9qu_k$(listOf_0((new (Builder_0())(Companion_getInstance_3().__createSecret_input_1)).value_oig1rm_k$(new (CompiledVariable())('input')).build_1k0s4u_k$())).selections_gjxob8_k$(this.__createSecret_1).build_1k0s4u_k$());
      }
    }
    initMetadataForObject($, 'CreateSecretMutationSelections');
    CreateSecretMutationSelectionsClass = $;
  }
  return CreateSecretMutationSelectionsClass;
}
var CreateSecretMutationSelections_instance;
function CreateSecretMutationSelections_getInstance() {
  if (CreateSecretMutationSelections_instance === VOID)
    new (CreateSecretMutationSelections())();
  return CreateSecretMutationSelections_instance;
}
//region block: exports
export {
  CreateSecretMutationSelections_getInstance as CreateSecretMutationSelections_getInstancewalai12czjs9,
};
//endregion

//# sourceMappingURL=CreateSecretMutationSelections.mjs.map
